import React from 'react';
import { useI18n, LANGUAGES } from '@/i18n';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { Languages } from 'lucide-react';

export default function LanguageSwitcher() {
  const { lang, setLang } = useI18n();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-switcher-btn"
        className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs text-white/70 hover:text-white hover:bg-white/5 transition border border-white/10"
        title="Language"
      >
        <Languages className="w-3.5 h-3.5" />
        <span className="hidden md:inline uppercase tracking-wider font-bold">{current.code}</span>
        <span className="md:hidden">{current.flag}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="glass-strong text-white border-white/10 min-w-[160px]">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`focus:bg-white/10 cursor-pointer ${lang === l.code ? 'text-[#FF007F]' : ''}`}
          >
            <span className="mr-2">{l.flag}</span> {l.label}
            {lang === l.code && <span className="ml-auto text-[10px]">✓</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
